import NumberInput from "../../../components/NumberInput";
import React, { useState } from "react";
import { FormValidationNotice, RequiredMark } from "../../../components/FormValidation";
import ItemAvatar from "../../../components/ItemAvatar";
import AkasSelect from "../../../components/AkasSelect";

const emptyDetail = {
  item_type: "material",
  item_id: "",
  item_name: "",
  unit: "",
  system_stock: 0,
  physical_stock: 0,
  note: "",
};

const FormStockOpname = (props) => {
  const { isEdit, closeModal, formState, setFormState, materials, products, isLoading, handleAdd, handleUpdate } =
    props;
  const [validationAttempted, setValidationAttempted] = useState(false);

  const getItems = (type) => (type === "material" ? materials : products);

  const updateDetail = (index, field, value) => {
    setFormState((previous) => ({
      ...previous,
      details: previous.details.map((detail, detailIndex) => {
        if (detailIndex !== index) return detail;

        if (field === "item_type") {
          return { ...emptyDetail, item_type: value };
        }

        if (field === "item_id") {
          const item = getItems(detail.item_type).find((candidate) => candidate.id === Number(value));
          return {
            ...detail,
            item_id: value ? Number(value) : "",
            item_name: item?.name || "",
            unit: item?.unit || "",
            system_stock: Number(item?.stock || 0),
            physical_stock: Number(item?.stock || 0),
          };
        }

        return { ...detail, [field]: value };
      }),
    }));
  };

  const addDetail = () => {
    setFormState((previous) => ({
      ...previous,
      details: [...previous.details, { ...emptyDetail }],
    }));
  };

  const removeDetail = (index) => {
    setFormState((previous) => ({
      ...previous,
      details: previous.details.filter((_, detailIndex) => detailIndex !== index),
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setValidationAttempted(true);
    const invalidDetail = formState.details.some((detail) =>
      !detail.item_id || Number(detail.physical_stock) < 0 || !Number.isFinite(Number(detail.physical_stock)) ||
      (detail.item_type === "product" && !Number.isInteger(Number(detail.physical_stock))),
    );
    if (!formState.opname_date || !formState.details.length || invalidDetail) return;
    const success = isEdit ? await handleUpdate() : await handleAdd();
    if (success) {
      document.querySelector("#modal-form-stock-opname .btn-close")?.click();
    }
  };

  return (
    <div
      className="modal modal-blur fade"
      id="modal-form-stock-opname"
      tabIndex="-1"
      role="dialog"
      aria-hidden="false"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      style={{ backgroundColor: "rgba(0, 0, 0, 0.3)" }}>
      <div className="modal-dialog modal-dialog-centered modal-xl" role="document">
        <form className="modal-content" onSubmit={handleSubmit} noValidate>
          <div className="modal-header">
            <h5 className="modal-title">Stock Opname {!isEdit ? "Baru" : "Edit"}</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={closeModal}></button>
          </div>
          <div className="modal-body">
            <FormValidationNotice
              errors={validationAttempted ? {
                ...(!formState.opname_date ? { opname_date: "Tanggal wajib diisi." } : {}),
                ...(!formState.details.length ? { details: "Minimal satu item wajib diisi." } : {}),
                ...formState.details.reduce((result, detail, index) => {
                  if (!detail.item_id) result[`details.${index}.item_id`] = "Item wajib dipilih.";
                  if (!Number.isFinite(Number(detail.physical_stock)) || Number(detail.physical_stock) < 0) result[`details.${index}.physical_stock`] = "Stok fisik minimal 0.";
                  else if (detail.item_type === "product" && !Number.isInteger(Number(detail.physical_stock))) result[`details.${index}.physical_stock`] = "Stok fisik produk harus bilangan bulat.";
                  return result;
                }, {}),
              } : {}}
              title="Lengkapi data stock opname yang ditandai."
            />
            <div className="row">
              <div className="col-lg-4">
                <div className="mb-3">
                  <label className="form-label">Tanggal Opname<RequiredMark /></label>
                  <input
                    type="date"
                    name="opname_date"
                    className={`form-control${validationAttempted && !formState.opname_date ? " is-invalid" : ""}`}
                    value={formState.opname_date}
                    required
                    onChange={(event) => setFormState((previous) => ({ ...previous, opname_date: event.target.value }))}
                  />
                  {validationAttempted && !formState.opname_date ? <div className="invalid-feedback d-block">Tanggal opname wajib diisi.</div> : null}
                </div>
              </div>
              <div className="col-lg-8">
                <div className="mb-3">
                  <label className="form-label">Catatan</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="catatan stock opname"
                    value={formState.note}
                    maxLength={1000}
                    onChange={(event) => setFormState((previous) => ({ ...previous, note: event.target.value }))}
                  />
                </div>
              </div>
            </div>

            <div className="d-flex align-items-center mb-2">
              <div>
                <h3 className="card-title mb-0">Detail Stok Fisik</h3>
                <p className="text-secondary m-0">Masukkan jumlah stok yang ditemukan saat pengecekan.</p>
              </div>
              <button type="button" className="btn btn-primary btn-sm ms-auto" onClick={addDetail}>
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  className="icon">
                  <path d="M12 5v14M5 12h14" />
                </svg>
                Tambah Item
              </button>
            </div>

            <div className="table-responsive border rounded">
              <table className="table table-vcenter mb-0">
                <thead className="table-header">
                  <tr>
                    <th className="w-1">No.</th>
                    <th style={{ minWidth: 130 }}>Tipe</th>
                    <th style={{ minWidth: 220 }}>Material / Produk</th>
                    <th className="text-center">Stok Sistem</th>
                    <th style={{ minWidth: 130 }}>Stok Fisik</th>
                    <th className="text-center">Selisih</th>
                    <th style={{ minWidth: 180 }}>Catatan</th>
                    <th className="w-1"></th>
                  </tr>
                </thead>
                <tbody>
                  {formState.details.map((detail, index) => {
                    const selectedKeys = formState.details
                      .filter((_, detailIndex) => detailIndex !== index)
                      .map((selected) => `${selected.item_type}:${selected.item_id}`);
                    const precision = detail.item_type === "material" ? 4 : 0;
                    const difference = Number(
                      (Number(detail.physical_stock || 0) - Number(detail.system_stock || 0)).toFixed(precision),
                    );
                    const selectedItem = getItems(detail.item_type).find(
                      (item) => Number(item.id) === Number(detail.item_id),
                    );

                    return (
                      <tr key={`${detail.item_type}-${detail.item_id || "new"}-${index}`}>
                        <td>{index + 1}.</td>
                        <td>
                          <AkasSelect
                            name={`details.${index}.item_id`}
                            className={`form-select${validationAttempted && !detail.item_id ? " is-invalid" : ""}`}
                            value={detail.item_type}
                            onChange={(event) => updateDetail(index, "item_type", event.target.value)}>
                            <option value="material">Material</option>
                            <option value="product">Produk</option>
                          </AkasSelect>
                          {validationAttempted && !detail.item_id ? <div className="invalid-feedback d-block">Material atau produk wajib dipilih.</div> : null}
                        </td>
                        <td>
                          <div className="d-flex align-items-center gap-2">
                            {selectedItem ? (
                              <ItemAvatar
                                name={selectedItem.name}
                                image={selectedItem?.image_path || selectedItem?.image}
                                size="sm"
                              />
                            ) : null}
                            <AkasSelect
                              className="form-select"
                              value={detail.item_id}
                              required
                              onChange={(event) => updateDetail(index, "item_id", event.target.value)}>
                              <option value="">-- Pilih Item --</option>
                              {getItems(detail.item_type)
                                .filter(
                                  (item) =>
                                    Number(detail.item_id) === item.id ||
                                    !selectedKeys.includes(`${detail.item_type}:${item.id}`),
                                )
                                .map((item) => (
                                  <option key={item.id} value={item.id}>
                                    {item.name}
                                  </option>
                                ))}
                            </AkasSelect>
                          </div>
                        </td>
                        <td className="text-center fw-bold">
                          {detail.system_stock || 0} {detail.unit}
                        </td>
                        <td>
                          <div className="input-group">
                            <NumberInput
                              type="number"
                              name={`details.${index}.physical_stock`}
                              min="0"
                              step={detail.item_type === "material" ? "0.0001" : "1"}
                              className={`form-control${validationAttempted && (
                                !Number.isFinite(Number(detail.physical_stock)) || Number(detail.physical_stock) < 0 ||
                                (detail.item_type === "product" && !Number.isInteger(Number(detail.physical_stock)))
                              ) ? " is-invalid" : ""}`}
                              value={detail.physical_stock}
                              required
                              onChange={(event) => updateDetail(index, "physical_stock", event.target.value)}
                            />
                            {detail.unit ? <span className="input-group-text">{detail.unit}</span> : null}
                          </div>
                          {validationAttempted && !Number.isFinite(Number(detail.physical_stock)) ? <div className="invalid-feedback d-block">Stok fisik wajib berupa angka.</div> : null}
                          {validationAttempted && Number(detail.physical_stock) < 0 ? <div className="invalid-feedback d-block">Stok fisik tidak boleh negatif.</div> : null}
                          {validationAttempted && detail.item_type === "product" && Number(detail.physical_stock) >= 0 && !Number.isInteger(Number(detail.physical_stock)) ? <div className="invalid-feedback d-block">Stok fisik produk harus bilangan bulat.</div> : null}
                        </td>
                        <td className="text-center">
                          <span
                            className={`badge ${difference === 0 ? "bg-success-lt" : difference > 0 ? "bg-blue-lt" : "bg-danger-lt"}`}>
                            {difference > 0 ? "+" : ""}
                            {difference}
                          </span>
                        </td>
                        <td>
                          <input
                            type="text"
                            className="form-control"
                            value={detail.note || ""}
                            maxLength={255}
                            placeholder="catatan item"
                            onChange={(event) => updateDetail(index, "note", event.target.value)}
                          />
                        </td>
                        <td>
                          <button
                            type="button"
                            className="btn btn-icon bg-danger-lt"
                            disabled={formState.details.length === 1}
                            onClick={() => removeDetail(index)}
                            aria-label="Hapus item">
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2">
                              <path d="M4 7h16M10 11v6M14 11v6M5 7l1 14h12l1-14M9 7V4h6v3" />
                            </svg>
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-link link-secondary btn-3" data-bs-dismiss="modal">
              Cancel
            </button>
            {isEdit ? (
              <button type="submit" className="btn btn-primary btn-5 ms-auto" disabled={isLoading}>
                {isLoading ? "Menyimpan..." : "Edit Data"}
              </button>
            ) : (
              <button type="submit" className="btn btn-primary btn-5 ms-auto" disabled={isLoading}>
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  className="icon">
                  <path d="M12 5v14M5 12h14" />
                </svg>
                {isLoading ? "Menyimpan..." : "Tambah Data"}
              </button>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

export default FormStockOpname;
